import VueRouter from "vue-router"
import Vue from "vue"
Vue.use(VueRouter)
import routes from "./routes"

const router = new VueRouter({
  routes
})

export default router
